
import { mapGetters } from 'vuex';
import { urlParser } from '../../utils';
import { youtubeRegex, vimeoRegex } from '../../constants/regex';

export default {
  props: {
    headline: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
    media: {
      type: Object,
      default: () => ({
        url: '',
        title: '',
      }),
    },
    link: {
      type: Object,
      default: () => ({
        url: '',
        title: '',
      }),
    },
    email: {
      type: Object,
      default: () => ({
        title: '',
        address: '',
        subject: '',
      }),
    },
    id: {
      type: String,
      default: '',
    },
    parentId: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters('chatbotStore', ['getConversationByNode']),

    mediaTitle() {
      return this.media?.title || this.headline;
    },

    cardLink() {
      let link = this.link?.url;
      if (!link && this.email?.address) {
        link = `mailto:${this.email.address}`;
        if (this.email?.subject) {
          link = `${link}?subject=${this.email?.subject}`;
        }
      }
      return link;
    },

    cardTarget() {
      try {
        return this.cardLink && urlParser(this.cardLink).hostname !== window.location.hostname ? '_blank' : undefined;
      } catch (err) {
        return '_blank';
      }
    },

    buttonTitle() {
      return this.link?.title || this.email?.title;
    },

    linkDomain() {
      return this.link?.url ? urlParser(this.link.url).hostname : '';
    },

    mediaUrl() {
      return this.media?.url?.replace(/\/image\/upload\//g, '$&c_fill,g_auto,w_330,h_186/');
    },

    mediaVideoUrl() {
      const { url } = this.media;
      if (!url) return '';

      const matchYoutube = url.match(youtubeRegex);

      if (matchYoutube) {
        return `https://youtube.com/embed/${matchYoutube[1]}`;
      }

      const matchVimeo = url.match(vimeoRegex);
      if (matchVimeo) {
        return `https://player.vimeo.com/video/${url.replace(/.*vimeo.com\/(.*)/g, '$1')}`;
      }

      return '';
    },
  },

  methods: {
    handleCardClick() {
      const nodeConv = this.getConversationByNode(this.parentId);

      if (nodeConv) {
        this.$tracking?.sendResponseEvent('cardNode', {
          carouselId: this.parentId,
          subNodeId: this.id,
          conversationId: nodeConv.id,
        });
      }
    },
  },
};
